import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { Iterable, IAdmin } from "types";

interface InitialState {
  current?: Iterable<IAdmin>;
}

const initialState: InitialState = {
  current: undefined,
};

const slice = createSlice({
  name: "admin",
  initialState: initialState,
  reducers: {
    setCurrentAdmin: (
      state,
      action: PayloadAction<Iterable<IAdmin> | undefined>
    ) => {
      state.current = action.payload;
    },
  },
});

export const {
  reducer,
  actions: { setCurrentAdmin },
} = slice;
